import umsomHelpers from './umsom.helpers';
import silkNav from './silk/nav';
// import silkTabs from './silk/tabs';
// import silkAccordion from './silk/accordion';
import flexslider from 'flexslider';

class UmsomSite {
	ready() {
		//Add JS control class
		$('html').addClass('js');
		
//		this.windowLoad();
		this.search();
//		this.removeDuplicateTitles();
//		this.leftNavDepth();
//		this.mainNavHighlight();
		this.menu();
		this.mobileSubMenu();
//		this.createDrawer();
//		this.breadcrumbs();
//		this.clickLoad();
//		this.loadContent();
//		this.resizeStop();
//		this.owlCarousel();
//		this.lightbox('a[data-imagelightbox]'); //For galleries
//		this.lightbox('a[rel=fancybox-gallery]'); //For default T4 images
		this.flexSlider();
//		this.linkIcon();
		this.silk();
//		this.loadVideoFromUrl();
//		this.iframeYoutube();
//		this.responsifyYoutube();
//		this.marquee();
//		this.ajaxStopped();
		this.search();
//		umsom.youtube.init();
	};
	
	search() {
		$('header form.search').submit(function(e) {
			e.preventDefault();
			var q = escape($(this).find('input[name=q]').val());
			var cx = escape($(this).find('input[name=cx]').val());
			var cof = escape($(this).find('input[name=cof]').val());
			window.location = $(this).attr('action') + '?q=' + q + '&cx=' + cx + '&cof=' + cof;
		});
	};
	
	/*
	 * Removes duplicate titles from T4 in some templates
	 *
	 */
	removeDuplicateTitles() {
		
		// Get titles
		var $fauxTitle = $('.page-title .faux-title:first'),
				$realTitle = $('h1:first');
		
		// If both titles exist and are the same, hide the real title
		if($fauxTitle.length && $realTitle.length) {
			if($fauxTitle.text() === $realTitle.text()) {
				$realTitle.hide();
			}
		}
		
	};
	
	mainNavHighlight() {
		var $mainNav = $('.navigation-menu .main-nav:first');
		
		if($mainNav.length) {
			
			//Get URL
			var url = umsomHelpers.getCurrentUrl();
		 
			//Find active link based on URL match ending with URL
			var $activeLink = $mainNav.find('a[href$="'+url+'"]');
			
			//If active link found
			if($activeLink.length) {
				
				//Add active class
				$activeLink.addClass('active').parents('li').each(function() {
					$(this).find('> a').addClass('active');
				});
				
			}
		}
	};
	
	leftNavDepth() {
		return;
		var contextualMenu = false;
		
		//Look for branch-at-level nav
		var $navBranchAtLevel = $('.subnav .branch-at-level:first');
		
		//If found...
		if($navBranchAtLevel.length) {
			
			//Temp: Remove other old sub-navs
			$('.subnav').find('.silk-nav').not('.branch-at-level').remove();
			
			//Get URL
			var url = umsomHelpers.getCurrentUrl();
			
			//Find active link based on URL match ending with URL
			var $activeLink = $navBranchAtLevel.find('a[href$="'+url+'"]');
			
			//If active link found
			if($activeLink.length) {
				
				//Add active class
				$activeLink.addClass('active').parents('li').each(function() {
					$(this).find('> a').addClass('active');
				});
				
				//If we want a contextual menu (the menu oiptions change as you go up the tree)
				if(contextualMenu) {
					
					//Get parent
					var $parent = $activeLink.parent();
					var $grandParent = $parent.parents('li').find('a:first');
					var $context;

					//If this link has children
					if($parent.find('> ul:first').length) {
						$context = $parent.find('> ul:first');
					} else {
						$context = $parent.parent('ul');
					}
					
					//If grandparent, add back link to it
					if($grandParent.length) {
						$grandParent.addClass('back allow-default').prependTo($context);
						$('.allow-default').wrap('<li />');
					}

					//Set the nav to the current context
					$navBranchAtLevel.html($context);
					
				}
				
				
			}
			
		}
	};
	
	/*
	 * Fire functions on window load
	 *
	 */
	windowLoad() {
		$(window).load(function() {
			//Window load functions here...
		});
	};
	
	/*
	 * Fire functions when AJAX has finished
	 *
	 */
	ajaxStopped() {
		$(document).ajaxStop(function() {
			this.share();
		});
	};
	
	/*
	 * Load a video from passed URL paramter
	 *
	 */
	loadVideoFromUrl() {
		//Get parameters
		var videoType = umsomHelpers.getUrlParameter('video-type');
		var videoId = umsomHelpers.getUrlParameter('video-id');
		
		//Check content type param exists and isn't blank
		if(typeof videoType != 'undefined' && videoType !== '')
		{
			if(videoType === 'youtube') //YouTube content
			{
				umsom.youtube.renderVideo(videoId);
			}
			else if(videoType === 'brightcove') //Brightcove content
			{
				umsom.brightcove.renderVideo(videoId);
			}
		}
	};
	
	/*
	 * Menu manipulations so menu can have different behaviors across different screen sizes
	 *
	 */
	menu() {
		//Clone search form
		$('form.search').clone().appendTo('.search-container');
		
		//Add close button to menu
		$('.navigation-menu').prepend('<a href="#" class="umsom-menu"></a>');
		
		//Toggle menu close
		$('.navigation-menu .umsom-menu').click(function(e){
			
			e.preventDefault();
			
			$('html').toggleClass('slide').find('.navigation-menu').toggleClass('open');
			
			//Reset position of nav
			$('.main-nav > ul:first').css('left', 0);
		});
		
		//Toggle mobile menu
		$('.menu-icon').click(function(e) {
			
			//Prevent default bahvior
			e.preventDefault();
			
			//Toggle the menu
			$('html').toggleClass('slide').find('.navigation-menu').toggleClass('open');
		});
		
		//Clone sub menu
			$('.sub-menu .nav-icon').clone().prependTo('.main-nav ul:first');
	};
	
	
	/*
	 * Creates a clone of the subnav for smaller screens
	 *
	 */
	mobileSubMenu() {
	 //If we have a subnav
	if( $('.subnav').length ) {
		
		$('.subnav')
			.find('nav:first')
			.clone()
			.prependTo('.content-wrapper')
			.wrap('<div class="mobile-subnav"><div class="mobile-subnav--wrapper"></div></div>');
		
		$('.mobile-subnav:first')
			.prepend('<div class="mobile-trigger"><h5><a href="#">Menu</a></h5></div>')
			.find('.mobile-trigger')
			.click(function(e) {
				e.preventDefault();
				$(this).next().slideToggle();
			});
	}
	};
	
	/*
	 * Drawer for hidden content
	 *
	 */
	createDrawer() {
		$('body')
			.append('<div class="drawer bottom"><a href="#" class="close" title="Close">&times;</a><div class="inner" /></div>')
			.end()
			.find('.drawer .close').click(function(e) {
				e.preventDefault();
				$(this).parent().removeClass('open').find('.inner').empty();
			});
	};
	
	/*
	 * Breadcrumbs
	 *
	 */
	breadcrumbs() {
		var $breadcrumbs = $('body .breadcrumbs:first');
		
		//Hide breadcrumbs on the home page
		if($breadcrumbs.find('a').length < 1)
		{
			$breadcrumbs.hide();
		}
	};
	
	/*
	 * Open drawer
	 *
	 */
	openDrawer(html) {
		$('body .drawer.bottom:first').find('.inner').html(html).end().addClass('open');
	};
	
	/*
	 * Load dynamic content on click
	 *
	 */
	clickLoad() {
		$('body').on('click', 'a[data-ajax-controller]', function(e) {
			
			e.preventDefault();
			
			this.loadController($(this));
			
		});
	};
	
	/*
	 * Controls the loading of AJAX based content
	 *
	 */
	loadController($el) {
		//Get controller
		var controller = $el.data('ajax-controller');
		
		//Dispatch to correct controller
		switch(controller)
		{
			case 'news':
				umsom.news.load($el);
				break;
			case 'youtube':
				umsom.youtube.load($el);
				break;
			case 'brightcove':
				umsom.brightcove.load($el);
				break;
			default:
				break;
		}
	};
	
	/*
	 * Passes dynamic content to correct AJAX controller
	 *
	 */
	loadContent() {
		$('[data-ajax-controller]').each(function() {
			this.loadController($(this));
		});
	};
	
	/*
	 * Get elements that need to be turned into carousels
	 *
	 */
	owlCarousel() {    
		$('.owl-carousel').not('[data-ajax-controller]').each(function() {
			this.carousel($(this));
		});
	};
	
	/*
	 * Get elements that need to be turned into flexsliders
	 *
	 */
	flexSlider() {
		var self = this;
		$('.flexslider').not('[data-ajax-controller]').each(function() {
			self.slideshow($(this));
		});
	};
	
	/*
	 * Create lightbox for image galleries
	 *
	 */
	lightbox(selector) { 
		var instance = $(selector).imageLightbox(
		{
				onStart: function() { umsom.lightbox.overlayOn(); umsom.lightbox.closeButtonOn(instance); umsom.lightbox.arrowsOn(instance, selector); },
				onEnd: function() { umsom.lightbox.overlayOff(); umsom.lightbox.captionOff(); umsom.lightbox.closeButtonOff(); umsom.lightbox.arrowsOff(); umsom.lightbox.activityIndicatorOff(); },
				onLoadStart: function() { umsom.lightbox.captionOff(); umsom.lightbox.activityIndicatorOn(); },
				onLoadEnd: function() { umsom.lightbox.captionOn(); umsom.lightbox.activityIndicatorOff(); $('.imagelightbox-arrow').css('display', 'block'); }
		});
	};
	
	/*
	 * Create carousel element
	 *
	 */
	carousel($el) {   
		var settings = {};

		settings.navigation = $el.data('owl-navigation');
		settings.pagination = $el.data('owl-pagination');
		settings.navigationText = $el.data('owl-navigation-text');
		settings.scrollPerPage = $el.data('owl-scroll-per-page');
		settings.singleItem = $el.data('owl-single-item');
		
		//Items per page
		settings.items = $el.data('owl-items'); //Number of items to appear when screen is above itemsDesktop
		settings.itemsDesktop = [1000, 3];
		settings.itemsDesktopSmall = false; //Inherit from itemsDesktop
		settings.itemsTablet = [600, 1]; //1 items between 600 and 0
		settings.itemsMobile = false; //Inherit from itemsTablet
			
		$el.owlCarousel(settings);
	};
	
	/*
	 * Create slideshow
	 *
	 */
	slideshow($el) {
		//Standard options
		var options = {
			animation: 'fade'
		};
		
		//Do we need to randomize the slides?
		if($el.hasClass('randomize'))
		{
			options.randomize = true;
		}
		
		$el.flexslider(options);
	};
	
	/*
	 * Create share functionality
	 *
	 */
	share() {
		if( $('.content').length && $('.share-button').length <= 0)
		{ 
			$('<div class="share-button" />').appendTo('.content');
			
			var options = {
				ui: {
					flyout: 'bottom right'
				}
			};
			
			new Share('.share-button', options);
		}
	};
	
	/*
	 * Add icons to content depending on type of content extension
	 *
	 */
	linkIcon() {
		$('.content a[href$="pdf"]').not('.pdf').each(function()
		{
			var $this = $(this);
			
			if($(this).parent().is('li'))
			{
				$this = $(this).parent();
			}
			
			$this.addClass('pdf');
		});
		
		$('.content a[href$="doc"]').not('.word').each(function()
		{
			var $this = $(this);
			
			if($(this).parent().is('li'))
			{
				$this = $(this).parent();
			}
			
			$this.addClass('word');
		});
	};
	
	initModule($el) {
		//Get the type
		var type = $el.data('module');
		
		//Init correct module
		switch(type)
		{
			case 'flexslider':
				umsom.site.slideshow($el);
				break;
			case 'carousel':
				umsom.site.carousel($el);
				break;
		}
	};
	
	/*
	 * Alters height of vertical tabs
	 *
	 */
	verticalTabs() {
		//Get element
		var $el = $('.vertical-tabs');
		
		//Always reset height
		$el.css('height','auto');
		
		//If on desktop
		if ($(window).width() >= mobileBreakpoint)
		{
			//Loop through any vertical tabs
			$el.each(function() {
			
				//Get tallest element
				var tallest = umsomHelpers.findTallestElement($(this).find('iframe'));
				
				//Set height if greater than 0
				if(tallest > 0)
				{
					$el.height(tallest).find('.silk-tabs__nav').height(tallest);
				}
			});
		}
	};
	
	/*
	 * Tab click callback
	 *
	 */
	tabClick() {
		
		//Get target tab ref
		var targetTab = $(this).attr('aria-controls');
		
		//Set video heights to auto
		$('#'+targetTab).find('.single-video').css('height','auto');
		
	};
	
	/*
	 * SILK bootstrap
	 *
	 */
	silk() {
		$('.silk-nav').silknav();
		// $('.silk-tabs, .vertical-tabs').silktabs({
		// 	tabClick: this.tabClick
		// });
		// $('.silk-accordion').silkaccordion();
	};
	
	/*
	 * Code that fires after resize event
	 *
	 */
	resizeStop() {
		$(window).bind('resize', function() {
			umsomHelpers.delay(function() {
				//Vertical tabs
				this.verticalTabs();

				//Reinit flexbox
				$('[data-flexbox]').each(function() {
					var $children = $(this).find('[data-flexbox-child]');
					if($children.length) {
						$children.css('height', 'auto');
						var tallest = umsomHelpers.findTallestElement($children);
						$children.css('height', tallest);
					}
				});
			}, 750);
		}).resize();
	};
	
	/*
	 * Convert YouTube objects to iframe based embeds
	 *
	 */
	iframeYoutube() {
		$('object > param[value*="youtube.com/v"]').each(function() {
			var $parent = $(this).parent();
			var videoId = umsom.youtube.getVideoId($(this).attr('value'));
			
			if(videoId !== 0)
			{
				var html = umsomHelpers.compileHTML('youtube-iframe', { id: videoId });
				$parent.after(html).remove();
			}
			
		});
	};
	
	/*
	 * Responsify YouTube iframe embeds
	 *
	 */
	responsifyYoutube() {
		$('iframe[src*="youtube.com/embed"]').each(function() {
			var $parent = $(this).parent();
			if(!$parent.hasClass('video-responsive'))
			{
				$(this).removeAttr('width height').wrap('<div class="video-responsive" />');
			}
		});
	};
	
	/*
	 * Create a marquee
	 *
	 */
	marquee() {
		$('.marquee').marquee();
	};
}

export default new UmsomSite();


// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/umsom/umsom.site.js